import Spinner from "@/components/spinner";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useDownloadFileResourceMutation } from "@/hooks/download-file-resource-mutation.hook";
import { useEditionById } from "@/hooks/edition-by-id.hook";
import { useListEditionResourcesByTag } from "@/hooks/list-edition-resources-by-tag.hook";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { InfoCircle } from "iconsax-react";
import { useAtomValue } from "jotai";

const SwornDeclarationAlert = () => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: edition } = useEditionById({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  const { data: resources } = useListEditionResourcesByTag({
    editionId: edition?.id || "",
    resourceLibraryId: edition?.libraryId || "",
    tag: "doctype::sworn_statement",
  });

  const resourceItem = resources?.[0];

  const mutation = useDownloadFileResourceMutation();

  const handleDownloadFile = () => {
    if (!resourceItem) {
      return;
    }

    mutation.mutate({
      resourceLibraryId: edition?.libraryId || "",
      resourceId: resourceItem.id,
      fileName: resourceItem.name.endsWith(".pdf")
        ? resourceItem.name
        : `${resourceItem.name}.pdf`,
    });
  };

  if (!resourceItem) {
    return null;
  }

  return (
    <Alert>
      <InfoCircle className="mt-1 h-5 w-5" color="#FFB92C" />
      <AlertTitle className="text-lg text-[#293038]">
        Declaración Jurada
      </AlertTitle>
      <AlertDescription className="mt-2 text-[#293038]">
        <p className="mb-2">
          Si esta pregunta no es aplicable a tu empresa, recuerda adjuntar una
          DD.JJ. en la sección de evidencias para completar la información.
          Recuerda que el formato es el mismo para todas las preguntas.
        </p>
        <p>
          <Button
            variant={"warning"}
            className="bg-[#FFB92C]"
            onClick={() => handleDownloadFile()}
            disabled={mutation.isPending}
          >
            {mutation.isPending && <Spinner className="mr-1" />}
            Descargar formato
          </Button>
        </p>
      </AlertDescription>
    </Alert>
  );
};

export default SwornDeclarationAlert;
